<template>
  <div class="ecommerce-order">
    <!-- 筛选条件 -->
    <div class="filter-section">
      <div class="date-filters">
        <div
          v-for="item in typeTabs"
          :key="item.value"
          class="date-tab"
          :class="{ active: item.value === type }"
          @click="changeTypeTab(item.value)"
        >
          {{ item.label }}
        </div>
        <div class="date-range">
          <el-date-picker
            v-model="timeRange"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="dateChange"
          />
        </div>
        <i class="el-icon-refresh" @click="refresh(false)" />
      </div>

      <!-- <div class="other-filters">
        <el-select
          v-model="shop"
          placeholder="所属店铺"
          size="small"
          class="filter-select"
        >
          <el-option label="所属店铺" value="" />
        </el-select>
        <el-select
          v-model="category"
          placeholder="选择商品分类"
          size="small"
          class="filter-select"
        >
          <el-option label="选择商品分类" value="" />
        </el-select>
        <div class="search-box">
          <el-input
            v-model="searchText"
            placeholder="商品名称/条形码"
            size="small"
            class="search-input"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              size="small"
              class="search-btn"
            />
          </el-input>
        </div>
        <el-button
          type="primary"
          size="small"
          class="excel-btn"
        >生成Excel</el-button>
      </div> -->
    </div>

    <!-- 统计数据卡片 -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="">
          <div class="stat-label">总订单量（含退单）</div>
          <div class="stat-value">{{ summary.count || 0 }}</div>
        </div>
        <div class="stat-icon">📊</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">
            总{{ type === 1 ? '销售额' : '采购金额' }}(元)
          </div>
          <div class="stat-value">{{ summary.actualAmount || 0 }}</div>
        </div>
        <div class="stat-icon">💰</div>
      </div>
      <!-- <div class="stat-card">
        <div>
          <div class="stat-label">总成本(元)</div>
          <div class="stat-value">{{ summary.totalCost }}</div>
        </div>
        <div class="stat-icon">💸</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">毛利(元)</div>
          <div class="stat-value">{{ summary.profitAmount }}</div>
        </div>
        <div class="stat-icon">📈</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">顾客退款(元)</div>
          <div class="stat-value">{{ summary.refundAmount }}</div>
        </div>
        <div class="stat-icon">🔄</div>
      </div> -->
    </div>

    <!-- 订单表格 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="orderItems"
          stripe
          size="large"
          class="order-table"
        >
          <!-- <el-table-column prop="index" label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="orderNo"
            label="订单编号"
            min-width="160"
            align="center"
          />
          <el-table-column
            prop="createTime"
            label="下单时间"
            min-width="130"
            align="center"
          />
          <el-table-column
            prop="orderSource"
            label="订单来源"
            min-width="90"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="orderTypeMap[scope.row.orderType] || 'info'"
                size="small"
              >
                {{ orderTypeTextMap[scope.row.orderType] || '未知' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="客户姓名"
            align="center"
          />
          <el-table-column
            prop="contactPhone"
            label="手机号"
            width="110"
            align="center"
          />
          <el-table-column
            prop="actualAmount"
            label="订单金额(元)"
            width="120"
            align="center"
          />
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="goToDetail(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 移动端表格卡片 -->
      <div v-loading="loading" class="mobile-cards">
        <div
          v-for="(item, index) in orderItems"
          :key="index"
          class="mobile-card"
        >
          <div class="card-header">
            <div class="card-title">订单编号{{ item.orderNo }}</div>
            <div class="card-index">序号：{{ index + 1 }}</div>
          </div>
          <div class="card-content">
            <div class="card-row">
              <span class="label">下单时间：</span>
              <span class="value">{{ item.createTime }}</span>
            </div>
            <div class="card-row">
              <span class="label">订单来源：</span>
              <span class="value">
                <el-tag
                  :type="orderTypeMap[item.orderType] || 'info'"
                  size="small"
                >
                  {{ orderTypeTextMap[item.orderType] || '未知' }}
                </el-tag>
              </span>
            </div>
            <div class="card-row">
              <span class="label">客户姓名：</span>
              <span class="value">{{ item.customerName || '-' }}</span>
            </div>
            <div class="card-row">
              <span class="label">手机号：</span>
              <span class="value">{{ item.contactPhone || '-' }}</span>
            </div>
            <div class="card-row">
              <span class="label">订单金额(元)：</span>
              <span class="value">{{ item.actualAmount || 0 }}</span>
            </div>
            <div class="card-row card-action">
              <el-button
                type="primary"
                size="small"
                class="detail-btn"
                @click="goToDetail(item)"
              >
                详情
              </el-button>
            </div>
          </div>
        </div>
        <el-empty v-if="orderItems.length === 0" description="暂无订单" />
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container pc-pagination">
        <el-pagination
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          background
          :pager-count="5"
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- 移动端分页组件 -->
      <div class="pagination-container mobile-pagination">
        <el-pagination
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          background
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus';
import {
  api_listAllOrderBank,
  api_sumOrderBank,
  api_listPurchaseBank,
  api_sumPurchaseBank
} from '@/api/index';
export default {
  name: 'OrderList',
  data() {
    return {
      loading: false,
      orderTypeMap: {
        1: 'primary',
        2: 'success',
        3: 'warning',
        4: 'primary'
      },
      orderTypeTextMap: {
        1: '门店',
        2: '电商',
        3: '销售单',
        4: '采购单'
      },
      orderSourceMap: {
        0: 'APP',
        1: '小程序',
        2: '线下订单',
        3: '小红书订单',
        4: '抖音订单',
        5: '代购订单'
      },
      timeRange: ['', ''],
      // 筛选条件
      typeTabs: [
        {
          label: '销售',
          value: 1
        },
        {
          label: '采购',
          value: 2
        }
      ],
      startDate: '',
      endDate: '',
      shop: '',
      category: '',
      searchText: '',
      type: 1,
      queryParams: {
        // type: 1,
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 订单数据
      orderItems: [],
      // 统计数据
      summary: {
        count: 0,
        actualAmount: 0,
        totalCost: 0,
        profitAmount: 0,
        refundAmount: 0
      }
    };
  },
  computed: {},
  created() {
    this.getOrderList();
    // 获取订单统计数据
    this.getOrderSummary();
    // this.total = this.orderItems.length;

    // 订阅企业切换事件
    eventBus.$on('enterpriseChanged', this.handleEnterpriseChange);
  },
  beforeDestroy() {
    // 取消订阅企业切换事件
    eventBus.$off('enterpriseChanged');
  },
  activated() {
    console.log('---activated---');
    // 组件被激活时调用，这里可以根据需要重新加载数据或执行其他操作
  },
  deactivated() {
    console.log('---deactivated---');
    // 组件被缓存时调用
  },
  methods: {
    changeTypeTab(type) {
      this.type = type;
      this.reload();
      // 获取订单统计数据
      this.getOrderSummary();
    },
    goToDetail(order) {
      // 跳转到订单详情页面，传递订单编号
      switch (order.orderType) {
        case '1':
          this.$router.push({
            path: `/store-order-detail/${order.id}`
          });
          break;
        case '2':
          this.$router.push({
            path: `/order-detail/${order.id}`
          });
          break;
        case '3':
          this.$router.push({
            path: `/sales-order-detail/${order.id}`
          });
          break;
        case '4':
          this.$router.push({
            path: `/purchase-detail/${order.id}`
          });
          break;
        default:
          break;
      }
    },
    async getOrderList() {
      try {
        this.loading = true;
        const api =
          this.type === 1 ? api_listAllOrderBank : api_listPurchaseBank;
        const res = await api(this.queryParams);
        this.orderItems = res.data.rows || [];
        this.total = res.data.total || 0;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // 获取订单统计数据
    async getOrderSummary() {
      try {
        const api = this.type === 1 ? api_sumOrderBank : api_sumPurchaseBank;
        const res = await api(this.queryParams);
        this.summary = res.data || {};
      } catch (error) {
        console.log(error);
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getOrderList();
    },
    changeStatusTab(e) {
      this.queryType = e;
      this.reload();
      // 获取订单统计数据
      this.getOrderSummary();
    },
    // 时间搜索
    dateChange(e) {
      this.timeRange = e;
      if (e) {
        const [startTime, endTime] = e;
        this.queryParams.startTime = startTime;
        this.queryParams.endTime = endTime;
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.reload();
      // 获取订单统计数据
      this.getOrderSummary();
    },
    reload(refresh = true) {
      if (refresh) {
        this.queryParams.pageNum = 1;
      }
      this.getOrderList();
    },
    // 刷新数据
    refresh(refresh = true) {
      this.reload(refresh);
      // 获取订单统计数据
      this.getOrderSummary();
    },
    // 处理企业切换
    handleEnterpriseChange() {
      this.reload();
      // 获取订单统计数据
      this.getOrderSummary();
    }
  }
};
</script>

<style scoped>
.order-list {
  /* padding: 20px; */
}

.order-list h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

/* 订单类型标签 */
.order-type-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-item {
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #666;
}

.tab-item.active {
  background-color: #5470c6;
  color: #fff;
}

/* 筛选条件 */
.filter-section {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-filters {
  display: flex;
  gap: 10px;
  /* margin-bottom: 15px; */
  flex-wrap: wrap;
  align-items: center;
}

.date-tab {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #666;
}

.date-tab.active {
  background-color: #5470c6;
  color: #fff;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
}

.date-input {
  width: 140px;
}

.other-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  min-width: 150px;
}

.search-box {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 200px;
}

.search-input {
  width: 100%;
}

.excel-btn {
  white-space: nowrap;
}

/* 统计数据 */
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 10px;
}

.stat-card {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  /* flex-direction: column;  */
  align-items: center;
  text-align: center;
}

.stat-label {
  font-size: 15px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #5470c6;
  margin-bottom: 8px;
}

.stat-icon {
  font-size: 16px;
  color: #999;
}

/* 表格样式 */
.table-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container {
  overflow-x: auto;
}

.order-table {
  width: 100%;
  font-size: 14px;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  font-size: 14px;
}

.mobile-pagination {
  display: none;
}
/* 移动端卡片样式 */
.mobile-cards {
  display: none;
  gap: 15px;
}

.mobile-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  background-color: #f9f9f9;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.card-index {
  font-size: 12px;
  color: #666;
}

.card-content {
  padding: 12px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.card-row:last-child {
  border-bottom: none;
}

.card-row .label {
  font-size: 14px;
  color: #666;
}

.card-row .value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.card-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .order-list {
    /* padding: 15px; */
  }

  .order-list h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .order-type-tabs {
    flex-wrap: wrap;
    padding: 8px;
  }

  .tab-item {
    padding: 6px 12px;
    font-size: 12px;
  }

  .filter-section {
    padding: 12px;
  }

  .date-filters {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 8px;
  }

  .date-range {
    width: 100%;
    justify-content: space-between;
  }

  .date-input {
    flex: 1;
  }

  .other-filters {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-select,
  .search-box,
  .excel-btn {
    width: 100%;
    min-width: auto;
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-card {
    padding: 12px;
  }

  .stat-value {
    font-size: 18px;
  }

  /* 隐藏表格，显示卡片 */
  .table-container {
    display: none;
  }

  .mobile-cards {
    display: flex;
    flex-direction: column;
  }
  .mobile-pagination {
    display: flex;
  }
  .pc-pagination {
    display: none;
  }
}

@media (max-width: 480px) {
  .order-list {
    /* padding: 10px 0; */
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-card {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: left;
  }

  .stat-label {
    margin-bottom: 0;
  }

  .stat-value {
    margin-bottom: 0;
    margin-right: 10px;
  }
}

.el-icon-refresh {
  font-size: 20px;
  color: #999;
  cursor: pointer;
}
</style>
